import {Component} from "react";
import {SubmitWatch} from './items/Watch'
import {SubmitNecklace} from './items/SubmitNecklace'
import * as React from "react";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {clearItem} from "../../actions/item";
import SubmitItemForm from '../../components/submitItemForm';
import { newPendingItem} from "../../actions/pendingItem";
import {updateSubmissionProgressState} from "../../actions/submissionProgress";

class _SubmitItem extends Component {
    components = {
        watch: SubmitWatch,
        necklace: SubmitNecklace
    }

    oldComponents = {
        ring: SubmitItemForm,
        bracelet: SubmitItemForm
    }

    redirects = {
        loose_diamond:"/#Loose_Diamonds"
    }

    constructor(props) {
        super(props)

        if ( this.redirects[this.props.params.itemType] ) {
            this.props.router.push(this.redirects[this.props.params.itemType])
        } else if ( !this.components[this.props.params.itemType] && !this.oldComponents[this.props.params.itemType]) {
            this.props.router.push("/")
        }
    }

    render() {
        if ( this.components[this.props.params.itemType] ) {
            return React.createElement(this.components[this.props.params.itemType], {...this.props, ...{location: this.props.location}})
        } else if ( this.oldComponents[this.props.params.itemType] ) {
            // for old components we don't need the props. they get it from redux state.
            return React.createElement(this.oldComponents[this.props.params.itemType],{params:this.props.params, location: this.props.location})
        }
        return null
    }
}

const mapStateToProps = ({Session, Form, Item, PendingItem}) => {
    return {
        Session,
        fields: Form.Fields,
        item: Item,
        pendingItem: PendingItem
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({clearItem, newPendingItem, updateSubmissionProgressState}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(_SubmitItem);
